import BaseModel from './BaseModel';

/** Class representing a manager. */
class Manager extends BaseModel {}

export default Manager;
